<template>
  <div>
    <MetodoFrenkel :selectedLang="selectedLang" />
    <EcosistemaFrenkel :selectedLang="selectedLang" />
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import MetodoFrenkel from '@/components/MetodoFrenkel.vue'
import EcosistemaFrenkel from '@/components/EcosistemaFrenkel.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'ServiciosPage',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  components: {
    MetodoFrenkel,
    EcosistemaFrenkel,
    SiteFooter
  },
  setup() {
    useSEO({
      title: 'Servicios de Ingeniería Industrial',
      description: 'Servicios especializados en Industria 4.0, automatización industrial, ingeniería de proceso, IT y consultoría. Frenkel Engineering tu aliado tecnológico.',
      path: '/servicios',
    });
  }
}
</script>

<style scoped>
/* Si necesitas estilos específicos para esta página, los puedes agregar aquí */
</style>
